<template>
  <base-layout>
    <div class="common-page login">
      <div class="container-fluid">
        <div class="row">
          <div class="col-sm-6">
            <h1 class="common-page__main-title">{{ $t('alreadyAccount') }}</h1>
            <dx-login-form />
            <hr class="divisor">
          </div>
          <div class="col-sm-6">
            <h2 class="common-page__main-title">{{ $t('createAccount') }}</h2>
            <dx-create-account-form />
          </div>
        </div>
      </div>
    </div>
  </base-layout>
</template>

<script>
import { mapGetters } from 'vuex'
import { BaseLayout } from '../layouts'
import {
  DxButton,
  DxSpinner,
  DxLoginForm,
  DxCreateAccountForm
} from '../components'
export default {
  name: 'login',
  components: {
    BaseLayout,
    DxButton,
    DxSpinner,
    DxLoginForm,
    DxCreateAccountForm
  },
  data () {
    return {
      model: {
        email: '',
        password: ''
      },
      sending: false
    }
  },
  computed: {
    ...mapGetters({
      loggedIn: 'getLoggedIn'
    })
  },
  created () {
    if (this.loggedIn) {
      this.$router.push({ name: 'home' })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Login.vue